import { __exports as barcodes } from "./index135.js";
import { __require as requireCODE39 } from "./index136.js";
import { __require as requireCODE128 } from "./index137.js";
import { __require as requireEAN_UPC } from "./index138.js";
import { __require as requireITF } from "./index139.js";
import { __require as requireMSI } from "./index140.js";
import { __require as requirePharmacode } from "./index141.js";
import { __require as requireCodabar } from "./index142.js";
import { __require as requireGenericBarcode } from "./index143.js";
var hasRequiredBarcodes;
function requireBarcodes() {
  if (hasRequiredBarcodes) return barcodes;
  hasRequiredBarcodes = 1;
  Object.defineProperty(barcodes, "__esModule", {
    value: true
  });
  var _CODE = requireCODE39();
  var _CODE2 = requireCODE128();
  var _EAN_UPC = requireEAN_UPC();
  var _ITF = requireITF();
  var _MSI = requireMSI();
  var _pharmacode = requirePharmacode();
  var _codabar = requireCodabar();
  var _GenericBarcode = requireGenericBarcode();
  barcodes.default = {
    CODE39: _CODE.CODE39,
    CODE128: _CODE2.CODE128,
    CODE128A: _CODE2.CODE128A,
    CODE128B: _CODE2.CODE128B,
    CODE128C: _CODE2.CODE128C,
    EAN13: _EAN_UPC.EAN13,
    EAN8: _EAN_UPC.EAN8,
    EAN5: _EAN_UPC.EAN5,
    EAN2: _EAN_UPC.EAN2,
    UPC: _EAN_UPC.UPC,
    UPCE: _EAN_UPC.UPCE,
    ITF14: _ITF.ITF14,
    ITF: _ITF.ITF,
    MSI: _MSI.MSI,
    MSI10: _MSI.MSI10,
    MSI11: _MSI.MSI11,
    MSI1010: _MSI.MSI1010,
    MSI1110: _MSI.MSI1110,
    pharmacode: _pharmacode.pharmacode,
    codabar: _codabar.codabar,
    GenericBarcode: _GenericBarcode.GenericBarcode
  };
  return barcodes;
}
export {
  requireBarcodes as __require
};
//# sourceMappingURL=index113.js.map
